import { useState, useEffect } from "react";
import ScreenTitle from "../components/common/ScreenTitle";
import styles from "./MyPageScreen.module.css";
import MapListView from "../components/common/MapListView";
import { path, subPaths } from "../components/common/Common";
import UserInfoArea from "../components/mypage/UserInfoArea";
import PurchaseHistory from "../components/mypage/PurchaseHistory";
import Tabs from "../components/common/Tabs";
import { useNavigate, useParams } from "react-router-dom";
import DataProvider from "../data_provider/DataProvider";

import { ListSearchReqBody } from "../data_provider/gateways/MapGateway";
import { Helmet } from "react-helmet-async";
import { useLoginStatus } from "../hooks/useLoginStatus";

export const enum SubPageList {
    Exit = -1,
    MyInfo,
    PurchaseInfo,
    MyMap,
}

const MyPageScreen = () => {
    const params = useParams();
    const navigate = useNavigate();
    const isLogin = useLoginStatus();

    const [subPage, setSubPage] = useState<SubPageList>(SubPageList.MyInfo);

    useEffect(() => {
        params.tab && subPaths.MYPAGE.includes(params.tab) && setSubPage(subPaths.MYPAGE.indexOf(params.tab));
    }, [params]);

    // 로그인 안 되어 있으면 라우팅 (렌더 중이 아닌 effect에서!)
    useEffect(() => {
        if (!isLogin) {
            navigate(path.ROOT, { replace: true });
        }
    }, [isLogin, navigate]);

    if (!isLogin) {
        // 리다이렉트 중이면 일시적으로 아무 것도 렌더하지 않음(깜빡임 방지)
        return null;
    }

    /**
     * 마이페이지 탭별 화면 전환용 함수
     * @returns 탭별 화면
     */
    const getMainContent = () => {
        switch (subPage) {
            case SubPageList.PurchaseInfo:
                return <PurchaseHistory />;
            case SubPageList.MyMap:
                return <MapListView updateData={getMyMapData} isMyMap={true} />;
            default:
                return <UserInfoArea />;
        }
    };

    /**
     * 내 지도 조회
     * @param no: 페이지 넘버
     * @returns MapItem[]
     */
    const getMyMapData = async (body: ListSearchReqBody) => {
        return await DataProvider.GetUserMapList(body);
    };

    const moveSubPage = (id: number) => {
        if (id === subPage) return;

        navigate([path.MYPAGE, subPaths.MYPAGE[id]].join("/"));
    };

    return (
        <>
            <Helmet>
                <title>마이페이지 - 모두의지도</title>
                <meta name="description" content="내 계정, 지도, 설정을 확인하세요" />
            </Helmet>
            <div className={`${styles.container} undraggable`}>
                <ScreenTitle title="마이페이지" />
                <Tabs options={["내 정보", "구매 내역", "내 지도"]} onItemClick={moveSubPage} tabMenuIdx={subPage!} />

                <div className={styles.info}>{getMainContent()}</div>
            </div>
        </>
    );
};

export default MyPageScreen;
